import CGU from '@/views/CGU.vue';
import CGV from '@/views/CGV.vue';
import ConfirmSuccess from '@/views/ConfirmSuccess.vue';
import Conversation from '@/views/Conversation.vue';
import Conversations from '@/views/Conversations.vue';
import DocumentUpload from '@/views/DocumentUpload.vue';
import Documents from '@/views/Documents.vue';
import Evaluations from '@/views/Evaluations.vue';
import HomePage from '@/views/HomePage.vue';
import Invoices from '@/views/Invoices.vue';
import NewInternship from '@/views/NewInternship.vue';
import PasswordChange from '@/views/PasswordChange.vue';
import PasswordForgotten from '@/views/PasswordForgotten.vue';
import PendingAccount from '@/views/PendingAccount.vue';
import Planning from '@/views/Planning.vue';
import Profile from '@/views/Profile.vue';
import Progression from '@/views/Progression.vue';
import PublicCGU from '@/views/PublicCGU.vue';
import PublicCGV from '@/views/PublicCGV.vue';
import Rank from '@/views/Rank.vue';
import Semester from '@/views/Semester.vue';
import SignIn from '@/views/SignIn.vue';
import SignUp from '@/views/SignUp.vue';
import SignUpSuccess from '@/views/SignUpSuccess.vue';
import Test from '@/views/Test.vue';
import TestList from '@/views/TestList.vue';
import TestResult from '@/views/TestResult.vue';
import Videos from '@/views/VideoList.vue';
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/connexion',
    name: 'SignIn',
    component: SignIn,
    meta: {
      public: true,
    },
  },
  {
    path: '/compte-en-attente',
    name: 'PendingAccount',
    component: PendingAccount,
    meta: {
      public: true,
    },
  },
  {
    path: '/inscription',
    name: 'SignUp',
    component: SignUp,
    meta: {
      public: true,
    },
  },
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
  },
  {
    path: '/plannings',
    name: 'Planning',
    component: Planning,
  },
  {
    path: '/documents',
    name: 'Documents',
    component: Documents,
  },
  {
    path: '/profil',
    name: 'Profile',
    component: Profile,
  },
  {
    path: '/factures',
    name: 'Invoices',
    component: Invoices,
  },
  {
    path: '/notes',
    name: 'Evaluations',
    component: Evaluations,
  },
  {
    path: '/notes/semestre',
    name: 'Semester',
    component: Semester,
  },
  {
    path: '/notes/progression',
    name: 'Progression',
    component: Progression,
  },
  {
    path: '/notes/classement',
    name: 'Rank',
    component: Rank,
  },
  {
    path: '/mot-de-passe-oublie',
    name: 'PasswordForgotten',
    component: PasswordForgotten,
    meta: {
      public: true,
    },
  },
  {
    path: '/changement-mot-de-passe',
    name: 'PasswordChange',
    component: PasswordChange,
    meta: {
      public: true,
    },
  },
  {
    path: '/succes-inscription',
    name: 'SignUpSuccess',
    component: SignUpSuccess,
    meta: {
      public: true,
    },
  },
  {
    path: '/succes-confirmation',
    name: 'ConfirmSuccess',
    component: ConfirmSuccess,
    meta: {
      public: true,
    },
  },
  {
    path: '/cgu',
    name: 'CGU',
    component: CGU,
  },
  {
    path: '/cgu-public',
    name: 'PublicCGU',
    component: PublicCGU,
    meta: {
      public: true,
    },
  },
  {
    path: '/cgv',
    name: 'CGV',
    component: CGV,
  },
  {
    path: '/cgv-public',
    name: 'PublicCGV',
    component: PublicCGV,
    meta: {
      public: true,
    },
  },
  {
    path: '/envoi-document',
    name: 'Envoi Document',
    component: DocumentUpload,
  },
  {
    path: '/nouvelle-inscription',
    name: 'Inscription stage',
    component: NewInternship,
  },
  {
    path: '/qcm',
    name: 'Liste QCM',
    component: TestList,
  },
  {
    path: '/qcm/:id',
    name: 'QCM',
    component: Test,
  },
  {
    path: '/qcm/:id/resultat',
    name: 'Résultat QCM',
    component: TestResult,
  },
  {
    path: '/concours_blancs',
    name: 'Liste Concours Blancs',
    component: TestList,
  },
  {
    path: '/concours_blancs/:id',
    name: 'Concours Blancs',
    component: Test,
  },
  {
    path: '/concours_blancs/:id/resultat',
    name: 'Résultat Concours Blancs',
    component: TestResult,
  },
  {
    path: '/annales',
    name: 'Liste des annales',
    component: TestList,
  },
  {
    path: '/annales/:id',
    name: 'Annale',
    component: Test,
  },
  {
    path: '/annales/:id/resultat',
    name: 'Résultat Annale',
    component: TestResult,
  },
  {
    path: '/conversations',
    name: 'Conversations',
    component: Conversations,
  },
  {
    path: '/conversations/new',
    name: 'Nouvelle conversation',
    component: Conversation,
  },
  {
    path: '/conversations/:id',
    name: 'Conversation',
    component: Conversation,
  },
  {
    path: '/videos',
    name: 'Videos List',
    component: Videos,
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
